import { Getters, Mutations, Actions, Module } from "vuex-smart-module";
import api from "@/lib/backend-api"
import { isLeft } from "fp-ts/lib/Either";
import { Data } from "@/types";

class State {
  endpoint = "";
  data: Data | undefined = undefined;
}

class ModuleGetters extends Getters<State> {
}

class ModuleMutations extends Mutations<State> {

  clearData() {
    this.state.data = undefined
  }

  mutateInit( endpoint : string ) {
    this.state.endpoint = endpoint;
  }

  mutateData( data: Data ) {
    this.state.data = data;
  }
}

class ModuleActions extends Actions<
  State,
  ModuleGetters,
  ModuleMutations,
  ModuleActions
> {

  initialize( endpoint : string ) {
    this.mutations.mutateInit( endpoint )
  }

  async load( args: any ) {
    const result = await api.getData( this.state.endpoint, args )
    // console.log(result)
    if (isLeft(result)) {
      console.error(result.left);
    } else {
      this.mutations.mutateData(result.right);
    }
  }

  clear() {
    this.mutations.clearData()
  }
}

const module = new Module({
  state: State,
  getters: ModuleGetters,
  mutations: ModuleMutations,
  actions: ModuleActions
});

export default module;
